function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M0 85.338h512v341.326H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M0 128.001h512v42.663H0z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#0052b4",
  d: "M0 170.664h512v42.663H0z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M0 256.001h512v42.663H0z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#0052b4",
  d: "M0 298.664h512v42.663H0z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M0 384.001h512v42.663H0z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M0 85.338h256v170.663H0z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M144 85.336h-32v69.334H0v32h112v69.333h32V186.67h112v-32H144z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M196.892 200.351L256 233.188v-32.837zm-41.066 0L256 256.003v-15.737l-71.847-39.915zm73.491 55.652l-73.491-40.832v40.832z",
  fill: "#0052b4"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M155.826 200.351L256 256.003v-15.737l-71.847-39.915z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M155.826 200.351L256 256.003v-15.737l-71.847-39.915z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M45.171 200.35L0 225.445V200.35zm55.003 7.077v48.575H12.745z",
  fill: "#0052b4"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M71.846 200.351L0 240.266v15.737l100.174-55.652z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M59.108 140.988L0 108.151v32.837zm41.066 0L0 85.336v15.737l71.847 39.915zM26.683 85.336l73.491 40.833V85.336z",
  fill: "#0052b4"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M100.174 140.988L0 85.336v15.737l71.847 39.915z"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M100.174 140.988L0 85.336v15.737l71.847 39.915z"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M210.829 140.989L256 115.895v25.094zm-55.003-7.077V85.337h87.429z",
  fill: "#0052b4"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M184.154 140.988L256 101.074V85.336l-100.174 55.652z"
});

const SvgHawaii = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHawaii, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/hawaii.b32a422e.svg";
export { ForwardRef as ReactComponent };